exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-md[data-v-d15285b8]{font-size:15px;font-weight:700}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/loaders/stylePostLoader.js!./node_modules/vue-loader/lib??vue-loader-options!./src/components/paywall/usage/SchedulePanel.vue?vue&type=style&index=0&id=d15285b8&prod&scoped=true&lang=css&
// module id = 1393
// module chunks = 0